import _ from 'lodash';
import React from 'react';
import styled from 'styled-components';
import { Margin, Padding, Queue, Stack, Text } from '../../components';
import { coreValuesData } from './shared';

const IconWrapper = styled.div`
  height: 100%;
  vertical-align: top;
`;

const CoreValuesComponentMobile = (props) => {
  let { coreValue, align } = props;
  let { icon, title, description } = coreValue || {
    icon: '',
    title: '',
    description: '',
  };
  return (
    <Queue size={5} height="100%">
      <IconWrapper>{icon}</IconWrapper>
      <Stack>
        <Text align={align} textType="primary1">
          {title}
        </Text>
        <Text align={align} textType="primary2">
          {description}
        </Text>
      </Stack>
    </Queue>
  );
};

export const CoreValuesMobile = () => {
  return (
    <Padding size={[7, 6]} backgroundRole="primary">
      <Stack size={4}>
        <Margin size={[0, 0, 6, 0]}>
          <Text textType="heading3">Our Values</Text>
        </Margin>
        <Stack size={7}>
          {_.flow((coreValuesData) =>
            _.map(coreValuesData, (coreValue, index) => {
              return (
                <CoreValuesComponentMobile
                  coreValue={coreValue}
                  align="left"
                  key={index}
                />
              );
            })
          )(coreValuesData)}
        </Stack>
      </Stack>
    </Padding>
  );
};
